import { OnInit, Component, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
    selector: 'app-antifraude-socio-relacao-pj',
    templateUrl: './antifraude-socio-relacao-pj.component.html',
    styleUrls: ['./../cadastral-pj/cadastral-pj.component.css']
})

export class AntifraudeSocioRelacaoPjComponent implements OnInit {

    @Input() dados:any;

    public txtButtonConsultar:string='Consultar agora';
    public consultando:Boolean=false;
    public naoSolicitou:Boolean=false;
    public naoEncontrouRegistros:Boolean=false;
    public modalRef:BsModalRef;

    constructor(private modalService:BsModalService) {}

    ngOnInit(): void {

        if(this.dados.antifraude_socio_relacao === undefined){
            this.naoSolicitou = true;
        } else if(this.dados.antifraude_socio_relacao === null) {
            this.naoEncontrouRegistros = true;
        }
    }
}